import { type OrderStatus } from '@/features/shop/services/Orders/types'
import {
  type SystemIconType,
  PickupIcon,
  CartIcon,
  PositiveCircleIcon,
  GroceriesIcon,
  HomeIcon,
  OrderIcon,
  VehicleTruckLargeIcon,
} from '@shipt/design-system-icons'

export const ORDER_STATUS_TEXTS = {
  DELIVERED: 'Order delivered',
  PICKED_UP: 'Order picked up',
  ORDER_PLACED: 'Order placed',
  ORDER_CLAIMED: 'Order claimed',
  SHOP_IN_PROGRESS: 'Shopping in progress...',
  SHOP_COMPLETE: 'Shopping complete',
  ON_THE_WAY: 'On the way',
  ORDER_CANCELLED: 'Order cancelled',
  READY_FOR_PICKUP: 'Order ready for pickup',
}

const ORDER_STATUS_ICONS = {
  DELIVERED: HomeIcon,
  PICKED_UP: PickupIcon,
  ORDER_PLACED: PositiveCircleIcon,
  ORDER_CLAIMED: OrderIcon,
  SHOP_IN_PROGRESS: GroceriesIcon,
  SHOP_COMPLETE: VehicleTruckLargeIcon,
  PREPARING_FOR_PICKUP: CartIcon,
  READY_FOR_PICKUP: PositiveCircleIcon,
}

type Status = {
  status: OrderStatus
  text: string
  icon: SystemIconType
}

const commonOrderStatuses: Status[] = [
  {
    status: 'open',
    text: ORDER_STATUS_TEXTS.ORDER_PLACED,
    icon: ORDER_STATUS_ICONS.ORDER_PLACED,
  },
  {
    status: 'claimed',
    text: ORDER_STATUS_TEXTS.ORDER_CLAIMED,
    icon: ORDER_STATUS_ICONS.ORDER_CLAIMED,
  },
  {
    status: 'shopping',
    text: 'Shopping',
    icon: ORDER_STATUS_ICONS.SHOP_IN_PROGRESS,
  },
]

export const deliveryOrderStatuses: Status[] = [
  ...commonOrderStatuses,
  {
    status: 'processed',
    text: ORDER_STATUS_TEXTS.SHOP_COMPLETE,
    icon: ORDER_STATUS_ICONS.SHOP_COMPLETE,
  },
  {
    status: 'delivered',
    text: 'Delivery',
    icon: ORDER_STATUS_ICONS.DELIVERED,
  },
]

export const pickupOrderStatuses: Status[] = [
  ...commonOrderStatuses,
  {
    status: 'processed',
    text: ORDER_STATUS_TEXTS.SHOP_COMPLETE,
    icon: ORDER_STATUS_ICONS.PREPARING_FOR_PICKUP,
  },
  {
    status: 'ready for pickup',
    text: ORDER_STATUS_TEXTS.READY_FOR_PICKUP,
    icon: ORDER_STATUS_ICONS.READY_FOR_PICKUP,
  },
  {
    status: 'delivered',
    text: 'Order pickup',
    icon: ORDER_STATUS_ICONS.PICKED_UP,
  },
]
